/* eslint-disable */
import home from './pages/home.vue'
import menuLateral from './views/menu-lateral.vue'
import diamantes from './pages/diamantes.vue'
import compromiso from './pages/compromiso.vue'
import detalles from './pages/detalles.vue'
import promesa from './pages/promesa.vue'
import argolla from './pages/argolla.vue'
import churumbela from './pages/churumbela.vue'
import personalizado from './pages/personalizado.vue'
import pulsera from './pages/pulsera.vue'
import dijes from './pages/dijes.vue'
import aretes from './pages/aretes.vue'
import zirconia from './pages/zirconia.vue'
import conjuntos from './pages/conjuntos.vue'
import cadenas from './pages/cadenas.vue'
import buscar from './pages/buscar.vue'
import acerca from './pages/acerca.vue'
import aviso from './pages/aviso.vue'
import ubicacion from './pages/ubicacion.vue'
import terminos from './pages/terminos.vue'
import contacto from './pages/contacto.vue'
import porque from './pages/porque.vue'
// import procesar from './pages/procesar.vue'
import envio from './pages/cuenta/envio.vue'
import finalizar from './pages/finalizar.vue'
import facturacion from './pages/cuenta/facturacion.vue'
import perfil from './pages/cuenta/perfil.vue'
import portafolio from './pages/portafolio.vue'
import completar from './pages/completar.vue'
import wishlist from './pages/wishlist.vue'
import carrito from './pages/carrito.vue'
import sesion from './pages/sesion.vue'
import ayudaMedida from './pages/ayuda-medida.vue'
import cookies from './pages/cookies.vue'
import boletin from './pages/boletin.vue'
import gracias from './pages/gracias.vue'
import notFound from './pages/not-found.vue'

export default [
  {
    path: '/',
    //component: home
    async (routeTo, routeFrom, resolve, reject) {
      // import('./pages/cuestionario/otro.vue').then(vc => {
      //   resolve({ component: vc.default })
      // })
      import('./pages/formulario_pc/formpc.vue').then(vc => {
        resolve({ component: vc.default })
      })
    }
  },
  {
    path: '/menu-lateral/',
    component: menuLateral
  },
  {
    path: '/diamantes/',
    component: diamantes
  },
  {
    path: '/compromiso/',
    component: compromiso,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/promesa/',
    component: promesa,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/argolla/',
    component: argolla,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/churumbela/',
    component: churumbela,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/personalizado/',
    component: personalizado
  },
  {
    path: '/pulsera/',
    component: pulsera,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/aretes/',
    component: aretes,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/dijes/',
    component: dijes,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/zirconia/',
    component: zirconia,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/conjuntos/',
    component: conjuntos,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/cadenas/',
    component: cadenas,
    routes: [
      {
        path: ':id',
        component: detalles
      }
    ]
  },
  {
    path: '/completar/',
    component: completar
  },
  {
    path: '/buscar/',
    component: buscar
  },
  {
    path: '/acerca/',
    component: acerca
  },
  {
    path: '/aviso/',
    component: aviso
  },
  {
    path: '/ubicacion/',
    component: ubicacion
  },
  {
    path: '/terminos/',
    component: terminos
  },
  {
    path: '/contacto/',
    component: contacto
  },
  {
    path: '/porque/',
    component: porque
  },
  {
    path: '/cuenta/envio/',
    component: envio
  },
  {
    path: '/cuenta/facturacion/',
    component: facturacion
  },
  {
    path: '/cuenta/perfil/',
    component: perfil
  },
  {
    path: '/finalizar/',
    component: finalizar
  },
  {
    path: '/carrito/',
    component: carrito,
    on: {
      pageAfterIn (e, page) {
        page.router.clearPreviousHistory()
      }
    }
  },
  {
    path: '/sesion/',
    component: sesion
  },
  {
    path: '/wishlist/',
    component: wishlist
  },
  {
    path: '/personalizado/seleccion/',
    async (routeTo, routeFrom, resolve, reject) {
      import('./pages/cuestionario/seleccion.vue').then(vc => {
        resolve({ component: vc.default })
      })
    }
  },
  {
    path: '/personalizado/compromiso/',
    async (routeTo, routeFrom, resolve, reject) {
      import('./pages/cuestionario/compromiso.vue').then(vc => {
        resolve({ component: vc.default })
      })
    },
    routes: [
      {
        path: 'decorativa',
        async (routeTo, routeFrom, resolve, reject) {
          import('./pages/cuestionario/compromiso/decorativa.vue').then(vc => {
            resolve({ component: vc.default })
          })
        }
      }
    ]
  },
  {
    path: '/personalizado/churumbela/',
    async (routeTo, routeFrom, resolve, reject) {
      import('./pages/cuestionario/churumbela.vue').then(vc => {
        resolve({ component: vc.default })
      })
    }
  },
  {
    path: '/personalizado/alternativo/',
    async (routeTo, routeFrom, resolve, reject) {
      import('./pages/cuestionario/alternativo.vue').then(vc => {
        resolve({ component: vc.default })
      })
    }
  },
  {
    path: '/personalizado/otro/',
    async (routeTo, routeFrom, resolve, reject) {
      import('./pages/cuestionario/otro.vue').then(vc => {
        resolve({ component: vc.default })
      })
    }
  },
  {
    path: '/personalizado/portafolio/',
    component: portafolio
  },
  {
    path: '/ayuda-medida/',
    component: ayudaMedida
  },
  {
    path: '/cookies/',
    component: cookies
  },
  {
    path: '/boletin/',
    component: boletin
  },
  {
    path: '/gracias/',
    component: gracias
  },
  {
    path: '(.*)',
    component: notFound
  }
]
